export default "__VITE_ASSET__DnPb3Jjs__"